<template>
  <div class="previewVideo">
    <video controls="" autoplay="" name="media" class="video">
      <source
        src="https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_1920_18MG.mp4"
        type="video/mp4"
      >
    </video>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.previewVideo {
  position: relative;
  width: 1200px;
  min-height: 640px;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  overflow: hidden;
  .video {
    width:100%;
    height: 100%;
  }
}
</style>
